<template>
  <header :class="['glass-topbar', 'glass-topbar--wordmark', { 'is-open': isOpen, 'is-scrolled': isScrolled }]">
    <router-link class="glass-topbar__brand glass-topbar__brand--wordmark" :to="brandTarget" @click="closeMenu">
      <img class="glass-topbar__brand-logo" src="/static/LOGOFOMO26_pro.png" alt="Fomo Planes" />
    </router-link>

    <div v-if="isAuthenticated" class="glass-topbar__session-pill">
      <small>Sesion activa</small>
      <strong>{{ identityLabel }}</strong>
    </div>

    <button class="glass-topbar__menu-button" type="button" @click="toggleMenu">
      <i class="fas" :class="isOpen ? 'fa-times' : 'fa-bars'"></i>
    </button>

    <div class="glass-topbar__nav">
      <nav class="glass-topbar__links" :style="toolbarStyle">
        <div class="glass-topbar__toolbar">
          <div class="glass-topbar__indicator">
            <div class="glass-topbar__indicator-glow"></div>
            <div class="glass-topbar__indicator-clip">
              <div class="glass-topbar__indicator-ring"></div>
            </div>
            <div class="glass-topbar__indicator-plate"></div>
          </div>
        </div>

        <div v-for="item in navItems" :key="item.name" class="glass-topbar__link-wrap">
          <component :is="item.href ? 'a' : 'router-link'" :class="linkClass(item)" :to="item.to" :href="item.href" @click="closeMenu">
            <i :class="['glass-topbar__link-icon', item.icon]"></i>
            <span class="glass-topbar__link-label">{{ item.label }}</span>
          </component>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderAdmin',

  data() {
    return {
      isOpen: false,
      isScrolled: false,
      showAdmin: false,
      isAuthenticated: false,
      identityLabel: '',
    }
  },

  computed: {
    isAdminContext() {
      return this.$route.name === 'AdminView' || this.$route.name === 'admin-login' || this.$route.path.startsWith('/admins')
    },

    brandTarget() {
      return this.isAdminContext ? { name: 'AdminView' } : { name: 'events2' }
    },

    navItems() {
      if (!this.isAuthenticated) {
        if (this.isAdminContext) {
          return [
            { name: 'admin-login', label: 'Entrar', icon: 'fas fa-shield-alt', to: { name: 'admin-login' }, accent: true },
            { name: 'preloader', label: 'OTP Host', icon: 'fas fa-right-to-bracket', to: { name: 'preloader' } },
          ]
        }

        return [
          { name: 'event-creation', label: 'Lanzar', icon: 'fas fa-plus-circle', to: { name: 'event-creation' }, accent: true },
          { name: 'preloader', label: 'Entrar', icon: 'fas fa-right-to-bracket', to: { name: 'preloader' } },
        ]
      }

      if (this.isAdminContext && this.showAdmin) {
        return [
          { name: 'AdminView-legacy', routeName: 'AdminView', label: 'Pagos', icon: 'fas fa-cash-register', to: { name: 'AdminView', query: { tab: 'legacy' } } },
          { name: 'AdminView-ledger', routeName: 'AdminView', label: 'Ledger', icon: 'fas fa-book', to: { name: 'AdminView', query: { tab: 'ledger' } } },
          { name: 'AdminView-events', routeName: 'AdminView', label: 'Eventos', icon: 'fas fa-calendar-alt', to: { name: 'AdminView', query: { tab: 'events' } } },
          { name: 'AdminView-reports', routeName: 'AdminView', label: 'Reportes', icon: 'fas fa-chart-line', to: { name: 'AdminView', query: { tab: 'reports' } } },
          { name: 'LogOut', routeName: 'LogOut', label: 'Salir', icon: 'fas fa-sign-out-alt', to: { name: 'LogOut' } },
        ]
      }

      const items = [
        { name: 'events2', label: 'Eventos', icon: 'fas fa-calendar-alt', to: { name: 'events2' } },
        { name: 'event-creation', label: 'Crear', icon: 'fas fa-plus-circle', to: { name: 'event-creation' }, accent: true },
        { name: 'finances', label: 'Finanzas', icon: 'fas fa-chart-line', to: { name: 'finances' } },
        { name: 'promo', label: 'Promos', icon: 'fas fa-bullhorn', to: { name: 'promo' } },
      ]

      if (this.showAdmin) {
        items.push({ name: 'AdminView', label: 'Admin', icon: 'fas fa-shield-alt', to: { name: 'AdminView' } })
      }

      items.push({ name: 'LogOut', label: 'Salir', icon: 'fas fa-sign-out-alt', to: { name: 'LogOut' } })
      return items
    },

    activeIndex() {
      const routeName = this.$route.name
      const routeTab = this.normalizeAdminTab(typeof this.$route.query.tab === 'string' ? this.$route.query.tab : '')
      const index = this.navItems.findIndex((item) => {
        if (item.routeName && item.routeName === routeName) {
          if (!item.to || !item.to.query || !item.to.query.tab) {
            return true
          }

          return this.normalizeAdminTab(item.to.query.tab) === routeTab
        }

        return item.name === routeName
      })
      return index >= 0 ? index : 0
    },

    toolbarStyle() {
      return {
        '--count': this.navItems.length,
        '--active-index': this.activeIndex,
      }
    },
  },

  mounted() {
    this.syncSession()
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleScroll() {
      this.isScrolled = (window.scrollY || window.pageYOffset || 0) > 18
    },

    syncSession() {
      this.isAuthenticated = window.localStorage.getItem('is_allowed') === 'true'
        || window.localStorage.getItem('is_admin') === 'true'
        || window.localStorage.getItem('is_superuser') === 'true'
        || window.localStorage.getItem('is_staff') === 'true'
      this.showAdmin = window.localStorage.getItem('is_admin') === 'true' || window.localStorage.getItem('is_superuser') === 'true'
      this.identityLabel = window.localStorage.getItem('username') || (this.isAdminContext ? 'Administrador' : 'Organizador')
    },

    toggleMenu() {
      this.isOpen = !this.isOpen
    },

    closeMenu() {
      this.isOpen = false
    },

    normalizeAdminTab(tab) {
      if (tab === 'transferencias' || tab === 'facturas' || tab === 'fees') {
        return 'legacy'
      }

      return tab
    },

    linkClass(item) {
      const index = this.navItems.findIndex((navItem) => navItem.name === item.name)
      return ['glass-topbar__link', { 'is-active': index === this.activeIndex, 'glass-topbar__cta': item.accent === true }]
    },
  },

  watch: {
    $route() {
      this.syncSession()
      this.closeMenu()
    },
  },
}
</script>

<style scoped>
.glass-topbar--wordmark::before {
  content: none !important;
  display: none !important;
}

.glass-topbar--wordmark.is-scrolled::before {
  content: none !important;
  display: none !important;
}

.glass-topbar__brand--wordmark {
  gap: 0;
  flex-shrink: 0;
  max-width: min(250px, 22vw);
}

.glass-topbar__brand-logo {
  display: block;
  width: 100%;
  height: auto;
  filter: drop-shadow(0 10px 24px rgba(116, 214, 200, 0.18));
}

.glass-topbar__session-pill {
  display: grid;
  gap: 2px;
  margin-left: auto;
  margin-right: 12px;
  padding: 8px 12px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(196, 206, 228, 0.1);
}

.glass-topbar__session-pill small {
  color: rgba(209, 220, 238, 0.66);
  font-size: 0.6rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.glass-topbar__session-pill strong {
  color: #eef4ff;
  font-size: 0.82rem;
  line-height: 1.1;
}

@media (max-width: 960px) {
  .glass-topbar__brand--wordmark {
    max-width: min(190px, calc(100vw - 104px));
  }

  .glass-topbar__session-pill {
    display: none;
  }
}
</style>
